// extracted by mini-css-extract-plugin
module.exports = {"split":"ClientInfo_split__1eTVT","column":"ClientInfo_column__3X7ez"};